import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { PrebuildModule } from '@dev/ee-api/ee-api-models';
import { EditorPrebuiltModule } from '@dev/template-editor';
import { ApplicationState } from '@/store';
import { getPrebuildModulesStore } from '@/store/prebuildModules/actions';

const getSavedList = (savedModules: PrebuildModule[], isSavingDisabled: boolean): EditorPrebuiltModule[] => {
    if (isSavingDisabled) {
        return null;
    }
    if (!savedModules) {
        return [];
    }
    return savedModules.reverse().map(({ Name: title, Id: id, Screenshot, Data }) => ({
        id,
        title,
        icon: (
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: `${(Screenshot.Height / Screenshot.Width) * 100}%`,
                    // backgroundSize: 'contain',
                    // backgroundImage: `url(${APIPATH}userfile${Screenshot?.Url})`,
                }}
            >
                {Screenshot?.Url && (
                    <img
                        loading="lazy"
                        width="100%"
                        height="auto"
                        src={`${APIPATH}/userfile${Screenshot.Url}`}
                        alt=""
                        style={{ position: 'absolute', top: 0, left: 0, maxWidth: '100%' }}
                    />
                )}
            </div>
        ),
        data: JSON.parse(Buffer.from(Data, 'base64').toString('utf8')),
    }));
};

export const useSavedList = (): EditorPrebuiltModule[] => {
    const { account } = useSelector((state: ApplicationState) => state);
    const { list: savedPrebuildModulesList } = useSelector(getPrebuildModulesStore);

    return useMemo(
        () => getSavedList(savedPrebuildModulesList, account?.GeneralInfo?.IsLegacy),
        [savedPrebuildModulesList, account?.GeneralInfo?.IsLegacy]
    );
};
